import React from 'react';
import PropTypes from 'prop-types';
import { useGetUser } from 'hooks';
import { Urls } from 'data';
import { Button } from 'components/ui/button';
import { Spinner } from 'components/ui/spinner';

// Options for method are ['kkiapay', 'momo', 'card']
const KkiapayTrigger = ({
  label = '',
  selectedAmount = 0,
  method = 'kkiapay',
  invoice,
  agency = {},
  onOpen = () => {},
}) => {
  const { currentUserEmail } = useGetUser();
  const isReady = Boolean(window.openKkiapayWidget);

  const handleOpenKkiapayWidget = () => {
    onOpen();
    if (isReady) {
      window.openKkiapayWidget({
        theme: '#318253',
        amount: selectedAmount,
        key: process.env.REACT_APP_KKIAPAY_PUBLIC_KEY,
        sandbox: true,
        email: currentUserEmail,
        reason: 'Frais adhésion Haddj',
        paymentmethod: method,
        data: { facture: invoice.code, nom_agence: agency.name, ifu_agence: agency.ifu },
        callback: `${process.env.REACT_APP_FRONTEND_BASE_URL}/${Urls.profile.base.replace('/', '')}/`,
      });
    }
  };

  return (
    <Button
      className="w-full"
      variant={isReady ? 'hajj' : 'disabled'}
      disabled={!isReady}
      onClick={handleOpenKkiapayWidget}
    >
      {!isReady && <Spinner />}
      {label}
    </Button>
  );
};

KkiapayTrigger.propTypes = {
  label: PropTypes.string,
  selectedAmount: PropTypes.number,
  method: PropTypes.string.isRequired,
  invoice: PropTypes.shape({
    id: PropTypes.string,
  }).isRequired,
  onOpen: PropTypes.func,
};

export default KkiapayTrigger;
